<template>
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <path
      fill-rule="evenodd"
      d="M8 2.8a10 10 0 1 1-5.2 13 1 1 0 1 1 1.7-.7 8.1 8.1 0 1 0 .7-7.5h2.1a1 1 0 1 1 0 1.9H2V4.2a1 1 0 0 1 1.9 0v2A10 10 0 0 1 8 2.8"
      clip-rule="evenodd"
    />
    <path
      d="M15 16.5H9v-1.2h6zM13 13H9v-1h4.1zm-2-2.8.1 3.8-.1 1q-.1.4-.6.7l-1-.4.3-.2.1-.5v-4.4q0-.8.3-1.5t1-.9 1.3-.3 1 .2q.6.2 1 .6A2 2 0 0 1 15 10l-1.2-.2q0-.4-.2-.7l-.5-.4a2 2 0 0 0-1.3 0l-.5.5z"
    />
  </svg>
</template>
